(function(angular){
	'use strict';
	
	angular
		.module('campaignsModule')
		.controller('TaxSeason', [
			'$cookies',
			'$scope',
			'APP_BASE_PATH',
			'futureEarningsFactory',
			'globalConfig',
			'mixpanelFactory',
			'planFactory',
			TaxSeasonFunction
		]);
	
	function TaxSeasonFunction(
		$cookies,
		$scope,
		APP_BASE_PATH, 
		futureEarningsFactory,
		globalConfig,
		mixpanelFactory,
		planFactory){
		
		var taxSeason = this;
		taxSeason.appPath = APP_BASE_PATH;
		taxSeason.ctaDestination = APP_BASE_PATH + '/start-investing';
		taxSeason.amountOptions = [{
			label: '$1,000',
			value: 1000
		},{
			label: '$5,000',
			value: 5000
		},{
			label: '$10,000',
			value: 10000
		},{
			label: '$15,000',
			value: 15000
		}, {
			label: 'Other',
			value: 'other'
		}];

		if(globalConfig.isInteractive) {
			taxSeason.amount = taxSeason.amountOptions[2];
		} else {
			taxSeason.amount = {
				label: '$2,932',
				value: 2932
			};
		}

		if(globalConfig.includeLandingAbTest) {
			var cookieJson = $cookies.get('com.fundrise.landing');

			if (cookieJson) {
				var landingCookie = JSON.parse(cookieJson);
				
				if(landingCookie.abTest) {
					taxSeason.requireEmail = landingCookie.requiresEmail;
					mixpanelFactory.register({ 'AB Landing Test Cookie': cookieJson });
					mixpanelFactory.track('AB Test Landing Page Viewed', landingCookie);
				}
			}
			
			if(angular.isUndefined(taxSeason.requireEmail)) {
				mixpanelFactory.track('Mixpanel AB Test Cookie Error', {'Cookie Value' : cookieJson});
				taxSeason.requireEmail = false;
			}
		}
		
		taxSeason.periods = 80;

		planFactory.getPlanData(['STANDARD']).then(function(response){
			angular.forEach(response.data, function(plan) {
				if(plan.planId === globalConfig.riaPlanId) {
					taxSeason.planData = plan;
					taxSeason.projectedAccountValue = futureEarningsFactory.getProjectedAccountValue(taxSeason.amount.value, 
						taxSeason.planData.projectedQuarterlyReturnMidpoint, taxSeason.periods);
					taxSeason.goal = plan.name;
				}
			});
		});

		$scope.$on('amountSelect:update', function(evt, amountOption) {
			taxSeason.amount = amountOption;
			taxSeason.projectedAccountValue = futureEarningsFactory.getProjectedAccountValue(taxSeason.amount.value, 
				taxSeason.planData.projectedQuarterlyReturnMidpoint, taxSeason.periods);
			mixpanelFactory.track('Tax Season Amount Select Changed', {
				amount: taxSeason.amount.value
			});
		});
	}
})(window.angular);